let toastApiRef = null;

export const globalToast = {
  register: (api) => {
    toastApiRef = api;
  },
  unregister: () => {
    toastApiRef = null;
  },
  error: (message, title = '') => {
    if (toastApiRef?.error) toastApiRef.error(message, title);
  },
  success: (message, title = '') => {
    if (toastApiRef?.success) toastApiRef.success(message, title);
  },
  warning: (message, title = '') => {
    if (toastApiRef?.warning) toastApiRef.warning(message, title);
  },
  info: (message, title = '') => {
    if (toastApiRef?.info) toastApiRef.info(message, title);
  },
};
